<script>
export default {
  data: () => ({
    staticMenu: true
  })
}
</script>

<template>
  <div id="app">
    <v-app id="inspire">
      <app-topbar @monitorarSwitch="(val) => staticMenu = val" :staticMenu='staticMenu'/>
      <div class="content" :class="{ 'content_left': staticMenu }">
        <app-tagview />
        <transition name="fade" mode="out-in">
          <keep-alive>
            <router-view />
          </keep-alive>
        </transition>
      </div>
      <app-footer :isActive='staticMenu' />
    </v-app>
    <ui-modal />
  </div>
</template>
